import UtilService from "../services/util.service";

export default {
  name: "toPhoneNumber",
  fn: value => {
    return UtilService.toPhoneNumber(value);
  }
};
